import {api_url, default_api_token, front_url, tokenId} from "../config/constant";
import {makeRequest, Methods} from "./request";
import {routes_api} from "../config/api";

export  function getTranslations(lang) {
    const url = api_url + routes_api.translations.get + '?lang=' + lang;
    return  makeRequest(url, Methods.GET, null, {'Authorization': default_api_token});
}
